module.exports = __webpack_public_path__ + "d2db634e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/favicon-72x72.png
// module id = 1517
// module chunks = 0